import { TReactSelectOption } from "../Interfaces/ExternalComponentsInterfaces"

export const REACT_SELECT_FAIL_FALLBACK_OPTIONS: TReactSelectOption[] = [
	{
		value: "_NO_OPTIONS",
		label: "Options failed to load",
	},
]

// ! TECH DEBT : Varbūt celt ārā kā tempalte, then again šis ir vieglāk un nav javeido atsevišķa komponente, kura knapi kko dara
export const HEIGHT_WITH_NAV_AND_FOOTER = "calc(100vh - 82px)"
export const HEIGHT_WITH_BIG_NAV_AND_FOOTER = "calc(100vh - 162px)"

export const RANDOM_PHOTO_URL_20 = "https://picsum.photos/20"

export const LOREM_IPSUM_TEXT =
	"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."

export const FILES_MAX_LENGTH = 10
export const FILE_MAX_SIZE = 5242880 * 5 // 5mb * 5 (25mb)
export const ACCEPTED_ATTACHMENT_EXT_AND_MIME_TYPES: { [x: string]: any } = {
	//"aac": "audio/aac",
	//"abw": "application/x-abiword",
	//"ai": "application/postscript",
	//"arc": "application/octet-stream",
	".asc": "application/x-pgp",
	//"avi": "video/x-msvideo",
	//"azw": "application/vnd.amazon.ebook",
	//"bin": "application/octet-stream",
	".bnd": "",
	//"bz": "application/x-bzip",
	//"bz2": "application/x-bzip2",
	//"csh": "application/x-csh",
	//"css": "text/css",
	".csv": "text/csv",
	".dbf": "x-gis/x-shapefile",
	".doc": "application/msword",
	".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	//"dll": "application/octet-stream",
	".edoc": "",
	//"eot": "application/vnd.ms-fontobject",
	//"epub": "application/epub+zip",
	//"gif": "image/gif",
	".gdb": "",
	".gpx": "application/gpx+xml",
	".hdr": "",
	//"ico": "image/x-icon",
	//"ics": "text/calendar",
	//"jar": "application/java-archive",
	".jpeg": "image/jpeg",
	".jpg": "",
	".jpw": "",
	".jpx": "",
	".jp2": "image/jp2",
	".json": "application/json",
	".kml": "application/vnd.google-earth.kml+xml",
	".kmz": "application/vnd.google-earth.kmz",
	".log": "text/plain",
	".mdb": "",
	//"mid": "audio/midi",
	//"midi": "audio/midi",
	//"mp2": "audio/mpeg",
	".mp3": "audio/mpeg",
	".mp4": "video/mp4",
	//"mpa": "video/mpeg",
	//"mpe": "video/mpeg",
	".mpeg": "video/mpeg",
	".msg": "application/vnd.ms-outlook",
	".mxd": "",
	".mxt": "",
	".m4a": "audio/m4a",
	".loc": "",
	".lyr": "",
	//".odp": "application/vnd.oasis.opendocument.presentation",
	//".ods": "application/vnd.oasis.opendocument.spreadsheet",
	//".odt": "application/vnd.oasis.opendocument.text",
	//"oga": "audio/ogg",
	//"ogv": "video/ogg",
	//"ogx": "application/ogg",
	//"otf": "font/otf",
	".qgs": "",
	".png": "image/png",
	".pdf": "application/pdf",
	".ppt": "application/vnd.ms-powerpoint",
	".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
	".prj": "",
	".rar": "application/x-rar-compressed",
	//"rtf": "application/rtf",
	//"sh": "application/x-sh",
	".shp": "x-gis/x-shapefile",
	".shx": "",
	".sqlite": "application/x-sqlite3",
	".sta": "application/x-photoshop",
	".svg": "image/svg+xml",
	//"swf": "application/x-shockwave-flash",
	//"tar": "application/x-tar",
	".tfw": "",
	".tif": "image/tiff",
	//".tiff": "",
	//"ttf": "font/ttf",
	".txt": "text/plain",
    ".vat": "",
	//"vsd": "application/vnd.visio",
	".war": "application/x-webarchive",
	//"wav": "audio/x-wav",
	//".weba": "audio/webm",
	//".webm": "video/webm",
	//".webp": "image/webp",
	//"xhtml": "application/xhtml+xml",
	".xls": "application/vnd.ms-excel",
	".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	".xml": "application/xml",
	//"xul": "application/vnd.mozilla.xul+xml",
	".zip": "application/zip",
	".7z": "application/x-7z-compressed",
	".E00": "application/octet-stream",
  }
